import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';
import {
  VerificationMethod,
  WithFailureProps,
} from '@app/store/transport-layer/types/verification';

interface NewDocumentsParticipantsAuthsResponse {
  id: string;
  methods: WithFailureProps<VerificationMethod>[];
  participant: {
    id: string;
    dataLabel: string;
  };
  documentId: string;
}

/**
 * GET 인증 상태 조회
 * @deprecated Endpoint path and response are modified in standardize-document-content
 * @see https://www.notion.so/modusign/bb8e24e723434ecc946dfecb85db5ee3#e39df5b009fc45aa8d1b5435495d5bcd
 */
export function getDocumentsParticipantsVerification({
  documentId,
  participantId,
  workspaceId,
}: {
  documentId: string;
  participantId: string;
  workspaceId: string;
}): Promise<NewDocumentsParticipantsAuthsResponse | null> {
  return requestApi<NewDocumentsParticipantsAuthsResponse>({
    url: withDocument(
      `/workspaces/${workspaceId}/documents/${documentId}/participants/${participantId}/verification`
    ),
    method: 'GET',
    credentials: true,
  }).then((response) => {
    // Not found the single resource
    // FYI: https://modusign.slack.com/archives/C03334LUVM4/p1661161725435879
    if (response.status === 204) {
      return null;
    }
    return response.data;
  });
}
